<template>
  <div v-if="task != null">
    <h6 class="mb-2">Conteo planificado</h6>
    <v-row>
      <v-col cols="12" md="3" v-if="task.stock_count_id">
        <div class="text-caption text-medium-emphasis">Conteo</div>
        <div>#{{ task.stock_count_id }}</div>
      </v-col>
      <v-col cols="12" md="3" v-if="task.ubicacion">
        <div class="text-caption text-medium-emphasis">Ubicación</div>
        <div>
          {{ task.ubicacion.code }}
          <span v-if="task.ubicacion.zona" class="text-caption text-grey-600">- {{ task.ubicacion.zona.label }}</span>
        </div>
      </v-col>
      <v-col cols="12" md="3" v-if="task.ubicacion && task.ubicacion.status">
        <div class="text-caption text-medium-emphasis">Estado de la ubicación</div>
        <v-chip size="small">{{ task.ubicacion.status.name }}</v-chip>
      </v-col>
      <v-col cols="12" md="3" v-if="task.sort_order != null">
        <div class="text-caption text-medium-emphasis">Orden de recorrido</div>
        <div>{{ task.sort_order }}</div>
      </v-col>
      <v-col cols="12" md="3">
        <div class="text-caption text-medium-emphasis">Stock reservado</div>
        <v-chip size="small" :color="task.has_reserved_stock ? 'warning' : 'grey'">
          {{ task.has_reserved_stock ? "Sí" : "No" }}
        </v-chip>
      </v-col>
    </v-row>

    <v-btn
      v-if="task.stock_count_id"
      size="small"
      variant="text"
      color="info"
      prepend-icon="mdi-open-in-new"
      class="mt-2"
      @click="verConteoCompleto"
    >
      Ver conteo completo
    </v-btn>
  </div>
</template>

<script>
import Constant from "@/constants/sections";

export default {
  name: "TaskViewDetalleConteo",
  props: {
    task: Object,
    descriptivos: { type: Array, default: () => [] },
  },
  methods: {
    verConteoCompleto() {
      this.$router.push("/" + Constant.SECTION_CONTEO + "/" + this.task.stock_count_id);
    },
  },
};
</script>
